export default __webpack_public_path__ + "605335bb2a5ada41db84fcfc3d05868a.svg";